export const sales = [
  {
    orderId: 10248,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 1740,
    date: "2013/01/06",
  },
  {
    orderId: 10249,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 850,
    date: "2013/01/13",
  },
  {
    orderId: 10250,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 2235,
    date: "2013/01/07",
  },
  {
    orderId: 10251,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 1965,
    date: "2013/01/03",
  },
  {
    orderId: 10252,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 880,
    date: "2013/01/10",
  },
  {
    orderId: 10253,
    region: "South America",
    country: "Brazil",
    city: "Rio de Janeiro",
    amount: 5260,
    date: "2013/01/17",
  },
  {
    orderId: 10254,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 2790,
    date: "2013/01/21",
  },
  {
    orderId: 10255,
    region: "South America",
    country: "Paraguay",
    city: "Asuncion",
    amount: 3140,
    date: "2013/01/01",
  },
  {
    orderId: 10256,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 6175,
    date: "2013/01/24",
  },
  {
    orderId: 10257,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 4575,
    date: "2013/01/11",
  },
  {
    orderId: 10258,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 3680,
    date: "2013/01/12",
  },
  {
    orderId: 10259,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 2260,
    date: "2013/01/01",
  },
  {
    orderId: 10260,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 2910,
    date: "2013/01/26",
  },
  {
    orderId: 10261,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 8400,
    date: "2013/01/05",
  },
  {
    orderId: 10262,
    region: "Asia",
    country: "Korea (Republic of)",
    city: "Seoul",
    amount: 1325,
    date: "2013/01/14",
  },
  {
    orderId: 10263,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 3920,
    date: "2013/01/05",
  },
  {
    orderId: 10264,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 2220,
    date: "2013/01/15",
  },
  {
    orderId: 10265,
    region: "Africa",
    country: "South Africa",
    city: "Pretoria",
    amount: 940,
    date: "2013/01/01",
  },
  {
    orderId: 10266,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 1630,
    date: "2013/01/10",
  },
  {
    orderId: 10267,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 2910,
    date: "2013/01/23",
  },
  {
    orderId: 10268,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 2600,
    date: "2013/01/14",
  },
  {
    orderId: 10269,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 4340,
    date: "2013/01/26",
  },
  {
    orderId: 10270,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 6650,
    date: "2013/01/24",
  },
  {
    orderId: 10271,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 490,
    date: "2013/01/22",
  },
  {
    orderId: 10272,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 3390,
    date: "2013/01/25",
  },
  {
    orderId: 10273,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 5160,
    date: "2013/02/20",
  },
  {
    orderId: 10274,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 5750,
    date: "2013/02/12",
  },
  {
    orderId: 10275,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 2805,
    date: "2013/02/13",
  },
  {
    orderId: 10276,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 2505,
    date: "2013/02/09",
  },
  {
    orderId: 10277,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 930,
    date: "2013/02/04",
  },
  {
    orderId: 10278,
    region: "South America",
    country: "Brazil",
    city: "Rio de Janeiro",
    amount: 1240,
    date: "2013/02/03",
  },
  {
    orderId: 10279,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 315,
    date: "2013/02/04",
  },
  {
    orderId: 10280,
    region: "South America",
    country: "Paraguay",
    city: "Asuncion",
    amount: 2870,
    date: "2013/02/18",
  },
  {
    orderId: 10281,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 5150,
    date: "2013/02/18",
  },
  {
    orderId: 10282,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 2725,
    date: "2013/02/20",
  },
  {
    orderId: 10283,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 2840,
    date: "2013/02/04",
  },
  {
    orderId: 10284,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 5840,
    date: "2013/02/13",
  },
  {
    orderId: 10285,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 6750,
    date: "2013/02/11",
  },
  {
    orderId: 10286,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 1200,
    date: "2013/02/03",
  },
  {
    orderId: 10287,
    region: "Asia",
    country: "Korea (Republic of)",
    city: "Seoul",
    amount: 4550,
    date: "2013/02/08",
  },
  {
    orderId: 10288,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 6040,
    date: "2013/02/17",
  },
  {
    orderId: 10289,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 2205,
    date: "2013/02/08",
  },
  {
    orderId: 10290,
    region: "Africa",
    country: "South Africa",
    city: "Pretoria",
    amount: 990,
    date: "2013/02/20",
  },
  {
    orderId: 10291,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 700,
    date: "2013/02/11",
  },
  {
    orderId: 10292,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 2325,
    date: "2013/02/15",
  },
  {
    orderId: 10293,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 930,
    date: "2013/02/21",
  },
  {
    orderId: 10294,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 1560,
    date: "2013/02/04",
  },
  {
    orderId: 10295,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 1740,
    date: "2013/03/04",
  },
  {
    orderId: 10296,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 3575,
    date: "2013/03/20",
  },
  {
    orderId: 10297,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 4500,
    date: "2013/03/04",
  },
  {
    orderId: 10298,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 1605,
    date: "2013/03/17",
  },
  {
    orderId: 10299,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 800,
    date: "2013/03/21",
  },
  {
    orderId: 10300,
    region: "South America",
    country: "Brazil",
    city: "Rio de Janeiro",
    amount: 640,
    date: "2013/03/08",
  },
  {
    orderId: 10301,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 735,
    date: "2013/03/19",
  },
  {
    orderId: 10302,
    region: "South America",
    country: "Paraguay",
    city: "Asuncion",
    amount: 2520,
    date: "2013/03/20",
  },
  {
    orderId: 10303,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 6675,
    date: "2013/03/18",
  },
  {
    orderId: 10304,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 3625,
    date: "2013/03/25",
  },
  {
    orderId: 10305,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 1200,
    date: "2013/03/07",
  },
  {
    orderId: 10306,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 2000,
    date: "2013/03/07",
  },
  {
    orderId: 10307,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 1410,
    date: "2013/03/10",
  },
  {
    orderId: 10308,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 2700,
    date: "2013/03/19",
  },
  {
    orderId: 10309,
    region: "Asia",
    country: "Korea (Republic of)",
    city: "Seoul",
    amount: 5950,
    date: "2013/03/24",
  },
  {
    orderId: 10310,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 5120,
    date: "2013/03/08",
  },
  {
    orderId: 10311,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 1980,
    date: "2013/03/17",
  },
  {
    orderId: 10312,
    region: "Africa",
    country: "South Africa",
    city: "Pretoria",
    amount: 1110,
    date: "2013/03/08",
  },
  {
    orderId: 10313,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 980,
    date: "2013/03/21",
  },
  {
    orderId: 10314,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 5460,
    date: "2013/03/19",
  },
  {
    orderId: 10315,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 3800,
    date: "2013/03/12",
  },
  {
    orderId: 10316,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 2610,
    date: "2013/03/04",
  },
  {
    orderId: 10317,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 3080,
    date: "2013/03/22",
  },
  {
    orderId: 10318,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 2010,
    date: "2013/03/23",
  },
  {
    orderId: 10319,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 1200,
    date: "2013/03/04",
  },
  {
    orderId: 10320,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 7680,
    date: "2013/04/15",
  },
  {
    orderId: 10321,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 1325,
    date: "2013/04/07",
  },
  {
    orderId: 10322,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 2835,
    date: "2013/04/10",
  },
  {
    orderId: 10323,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 3660,
    date: "2013/04/10",
  },
  {
    orderId: 10324,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 390,
    date: "2013/04/12",
  },
  {
    orderId: 10325,
    region: "South America",
    country: "Brazil",
    city: "Rio de Janeiro",
    amount: 4420,
    date: "2013/04/08",
  },
  {
    orderId: 10326,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 1755,
    date: "2013/04/13",
  },
  {
    orderId: 10327,
    region: "South America",
    country: "Paraguay",
    city: "Asuncion",
    amount: 2580,
    date: "2013/04/15",
  },
  {
    orderId: 10328,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 850,
    date: "2013/04/01",
  },
  {
    orderId: 10329,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 2825,
    date: "2013/04/10",
  },
  {
    orderId: 10330,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 540,
    date: "2013/04/06",
  },
  {
    orderId: 10331,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 1520,
    date: "2013/04/08",
  },
  {
    orderId: 10332,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 8760,
    date: "2013/04/26",
  },
  {
    orderId: 10333,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 1110,
    date: "2013/04/16",
  },
  {
    orderId: 10334,
    region: "Asia",
    country: "Korea (Republic of)",
    city: "Seoul",
    amount: 6850,
    date: "2013/04/19",
  },
  {
    orderId: 10335,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 1940,
    date: "2013/04/23",
  },
  {
    orderId: 10336,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 1980,
    date: "2013/04/21",
  },
  {
    orderId: 10337,
    region: "Africa",
    country: "South Africa",
    city: "Pretoria",
    amount: 3090,
    date: "2013/04/03",
  },
  {
    orderId: 10338,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 1640,
    date: "2013/04/24",
  },
  {
    orderId: 10339,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 3585,
    date: "2013/04/01",
  },
  {
    orderId: 10340,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 1770,
    date: "2013/04/01",
  },
  {
    orderId: 10341,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 4005,
    date: "2013/04/04",
  },
  {
    orderId: 10342,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 2870,
    date: "2013/04/02",
  },
  {
    orderId: 10343,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 960,
    date: "2013/04/20",
  },
  {
    orderId: 10344,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 8640,
    date: "2013/05/14",
  },
  {
    orderId: 10345,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 5450,
    date: "2013/05/24",
  },
  {
    orderId: 10346,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 2535,
    date: "2013/05/07",
  },
  {
    orderId: 10347,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 1155,
    date: "2013/05/20",
  },
  {
    orderId: 10348,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 3140,
    date: "2013/05/18",
  },
  {
    orderId: 10349,
    region: "South America",
    country: "Brazil",
    city: "Rio de Janeiro",
    amount: 2260,
    date: "2013/05/19",
  },
  {
    orderId: 10350,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 1215,
    date: "2013/05/23",
  },
  {
    orderId: 10351,
    region: "South America",
    country: "Paraguay",
    city: "Asuncion",
    amount: 1210,
    date: "2013/05/08",
  },
  {
    orderId: 10352,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 875,
    date: "2013/05/25",
  },
  {
    orderId: 10353,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 5400,
    date: "2013/05/03",
  },
  {
    orderId: 10354,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 5940,
    date: "2013/05/25",
  },
  {
    orderId: 10355,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 4700,
    date: "2013/05/03",
  },
  {
    orderId: 10356,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 5520,
    date: "2013/05/12",
  },
  {
    orderId: 10357,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 9210,
    date: "2013/05/22",
  },
  {
    orderId: 10358,
    region: "Asia",
    country: "Korea (Republic of)",
    city: "Seoul",
    amount: 7950,
    date: "2013/05/12",
  },
  {
    orderId: 10359,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 3740,
    date: "2013/05/24",
  },
  {
    orderId: 10360,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 990,
    date: "2013/05/02",
  },
  {
    orderId: 10361,
    region: "Africa",
    country: "South Africa",
    city: "Pretoria",
    amount: 3190,
    date: "2013/05/03",
  },
  {
    orderId: 10362,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 2430,
    date: "2013/05/11",
  },
  {
    orderId: 10363,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 7380,
    date: "2013/06/15",
  },
  {
    orderId: 10364,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 4475,
    date: "2013/06/08",
  },
  {
    orderId: 10365,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 1290,
    date: "2013/06/10",
  },
  {
    orderId: 10366,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 2250,
    date: "2013/06/10",
  },
  {
    orderId: 10367,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 350,
    date: "2013/06/22",
  },
  {
    orderId: 10368,
    region: "South America",
    country: "Brazil",
    city: "Rio de Janeiro",
    amount: 5480,
    date: "2013/06/24",
  },
  {
    orderId: 10369,
    region: "South America",
    country: "Argentina",
    city: "Buenos Aires",
    amount: 2355,
    date: "2013/06/10",
  },
  {
    orderId: 10370,
    region: "South America",
    country: "Paraguay",
    city: "Asuncion",
    amount: 1960,
    date: "2013/06/23",
  },
  {
    orderId: 10371,
    region: "Europe",
    country: "United Kingdom",
    city: "London",
    amount: 4125,
    date: "2013/06/06",
  },
  {
    orderId: 10372,
    region: "Europe",
    country: "Germany",
    city: "Berlin",
    amount: 7925,
    date: "2013/06/12",
  },
  {
    orderId: 10373,
    region: "Europe",
    country: "Spain",
    city: "Madrid",
    amount: 1120,
    date: "2013/06/22",
  },
  {
    orderId: 10374,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 5100,
    date: "2013/06/01",
  },
  {
    orderId: 10375,
    region: "Asia",
    country: "China",
    city: "Beijing",
    amount: 1500,
    date: "2013/06/25",
  },
  {
    orderId: 10376,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 5130,
    date: "2013/06/10",
  },
  {
    orderId: 10377,
    region: "Asia",
    country: "Korea (Republic of)",
    city: "Seoul",
    amount: 2475,
    date: "2013/06/10",
  },
  {
    orderId: 10378,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 2100,
    date: "2013/06/06",
  },
  {
    orderId: 10379,
    region: "Australia",
    country: "Australia",
    city: "Melbourne",
    amount: 3570,
    date: "2013/06/10",
  },
  {
    orderId: 10380,
    region: "Africa",
    country: "South Africa",
    city: "Pretoria",
    amount: 550,
    date: "2013/06/02",
  },
  {
    orderId: 10381,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 2850,
    date: "2013/06/26",
  },
  {
    orderId: 10382,
    region: "Europe",
    country: "Russian Federation",
    city: "Moscow",
    amount: 4280,
    date: "2013/06/19",
  },
  {
    orderId: 10383,
    region: "Australia",
    country: "Australia",
    city: "Sydney",
    amount: 1460,
    date: "2013/06/17",
  },
  {
    orderId: 10384,
    region: "North America",
    country: "Canada",
    city: "Edmonton",
    amount: 960,
    date: "2013/06/17",
  },
  {
    orderId: 10385,
    region: "Africa",
    country: "Egypt",
    city: "Cairo",
    amount: 1520,
    date: "2013/06/03",
  },
  {
    orderId: 10386,
    region: "Asia",
    country: "Japan",
    city: "Tokyo",
    amount: 6750,
    date: "2013/06/21",
  },
  {
    orderId: 10387,
    region: "North America",
    country: "United States",
    city: "New York",
    amount: 7260,
    date: "2013/07/14",
  },
  {
    orderId: 10388,
    region: "North America",
    country: "United States",
    city: "Los Angeles",
    amount: 2450,
    date: "2013/07/11",
  },
  {
    orderId: 10389,
    region: "North America",
    country: "United States",
    city: "Denver",
    amount: 3540,
    date: "2013/07/02",
  },
  {
    orderId: 10390,
    region: "North America",
    country: "Canada",
    city: "Vancouver",
    amount: 1950,
    date: "2013/07/03",
  },
];

export const selectedKeys = [
  10273, 10277, 10292, 10295, 10300, 10302, 10305, 10308, 10312, 10319, 10321,
  10323, 10326, 10328, 10331, 10334, 10335, 10341, 10351, 10353, 10356, 10362,
  10367, 10373, 10376, 10383, 10387,
];

// Mock data
export const products = [
  {
    id: "46956",
    description: "Lamictal XR 100mg Extended",
    hsc: true,
    supplier: "IPC",
    gcrImpact: "positive",
    unitPrice: 5.6,
    price: 521.2,
    avail: true,
    doNotSub: false,
    purchaseQty: 20,
  },
  {
    id: "46957",
    description: "Lamictal XR 100mg Extended",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 5.9,
    price: 631.2,
    avail: false,
    doNotSub: true,
    purchaseQty: 20,
  },
  {
    id: "46958",
    description: "Lamictal XR 100mg Extended-Release",
    hsc: true,
    supplier: "AAPA",
    gcrImpact: "average",
    unitPrice: 6.5,
    price: 525.2,
    avail: true,
    doNotSub: false,
    purchaseQty: 20,
  },
  {
    id: "46959",
    description: "Aamictal XR 100mg Extended",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 1.2,
    price: 671.2,
    avail: false,
    doNotSub: true,
    purchaseQty: 0,
  },
  {
    id: "46960",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 4.6,
    price: 541.22,
    avail: false,
    doNotSub: false,
    purchaseQty: 0,
  },
  {
    id: "46961",
    description: "Aamictal XR 100mg Extended",
    hsc: true,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 7.3,
    price: 411.3,
    avail: false,
    doNotSub: true,
    purchaseQty: 0,
  },
  {
    id: "46962",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 11.2,
    price: 121.2,
    avail: false,
    doNotSub: true,
    purchaseQty: 0,
  },
  {
    id: "46963",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 3.11,
    price: 741.2,
    avail: true,
    doNotSub: true,
    purchaseQty: 0,
  },
  {
    id: "46964",
    description: "Aamictal XR 100mg.",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 5.88,
    price: 532.2,
    avail: false,
    doNotSub: false,
    purchaseQty: 0,
  },
  {
    id: "46965",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: true,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 9.5,
    price: 451.2,
    avail: false,
    doNotSub: true,
    purchaseQty: 0,
  },
  {
    id: "46966",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 7.12,
    price: 361.2,
    avail: true,
    doNotSub: false,
    purchaseQty: 0,
  },
  {
    id: "46967",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 7.14,
    price: 668.2,
    avail: true,
    doNotSub: false,
    purchaseQty: 0,
  },
  {
    id: "46968",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 6.32,
    price: 241.78,
    avail: true,
    doNotSub: false,
    purchaseQty: 0,
  },
  {
    id: "46969",
    description: "Aamictal XR 100mg Extended-Release T...",
    hsc: false,
    supplier: "Masters",
    gcrImpact: "negative",
    unitPrice: 8.41,
    price: 664.45,
    avail: true,
    doNotSub: false,
    purchaseQty: 0,
  },
  // Add more mock data as needed
];


export const countryCodes =
  [
    {
      label: "Afghanistan",
      code: "+93",
      iso: "AF"
    },
    {
      label: "Aland Islands",
      code: "+358",
      iso: "AX"
    },
    {
      label: "Albania",
      code: "+355",
      iso: "AL"
    },
    {
      label: "Algeria",
      code: "+213",
      iso: "DZ"
    },
    {
      label: "AmericanSamoa",
      code: "+1684",
      iso: "AS"
    },
    {
      label: "Andorra",
      code: "+376",
      iso: "AD"
    },
    {
      label: "Angola",
      code: "+244",
      iso: "AO"
    },
    {
      label: "Anguilla",
      code: "+1264",
      iso: "AI"
    },
    {
      label: "Antarctica",
      code: "+672",
      iso: "AQ"
    },
    {
      label: "Antigua and Barbuda",
      code: "+1268",
      iso: "AG"
    },
    {
      label: "Argentina",
      code: "+54",
      iso: "AR"
    },
    {
      label: "Armenia",
      code: "+374",
      iso: "AM"
    },
    {
      label: "Aruba",
      code: "+297",
      iso: "AW"
    },
    {
      label: "Australia",
      code: "+61",
      iso: "AU"
    },
    {
      label: "Austria",
      code: "+43",
      iso: "AT"
    },
    {
      label: "Azerbaijan",
      code: "+994",
      iso: "AZ"
    },
    {
      label: "Bahamas",
      code: "+1242",
      iso: "BS"
    },
    {
      label: "Bahrain",
      code: "+973",
      iso: "BH"
    },
    {
      label: "Bangladesh",
      code: "+880",
      iso: "BD"
    },
    {
      label: "Barbados",
      code: "+1246",
      iso: "BB"
    },
    {
      label: "Belarus",
      code: "+375",
      iso: "BY"
    },
    {
      label: "Belgium",
      code: "+32",
      iso: "BE"
    },
    {
      label: "Belize",
      code: "+501",
      iso: "BZ"
    },
    {
      label: "Benin",
      code: "+229",
      iso: "BJ"
    },
    {
      label: "Bermuda",
      code: "+1441",
      iso: "BM"
    },
    {
      label: "Bhutan",
      code: "+975",
      iso: "BT"
    },
    {
      label: "Bolivia",
      code: "+591",
      iso: "BO"
    },
    {
      label: "Bosnia and Herzegovina",
      code: "+387",
      iso: "BA"
    },
    {
      label: "Botswana",
      code: "+267",
      iso: "BW"
    },
    {
      label: "Brazil",
      code: "+55",
      iso: "BR"
    },
    {
      label: "British Indian Ocean Territory",
      code: "+246",
      iso: "IO"
    },
    {
      label: "Brunei Darussalam",
      code: "+673",
      iso: "BN"
    },
    {
      label: "Bulgaria",
      code: "+359",
      iso: "BG"
    },
    {
      label: "Burkina Faso",
      code: "+226",
      iso: "BF"
    },
    {
      label: "Burundi",
      code: "+257",
      iso: "BI"
    },
    {
      label: "Cambodia",
      code: "+855",
      iso: "KH"
    },
    {
      label: "Cameroon",
      code: "+237",
      iso: "CM"
    },
    {
      label: "Canada",
      code: "+1",
      iso: "CA"
    },
    {
      label: "Cape Verde",
      code: "+238",
      iso: "CV"
    },
    {
      label: "Cayman Islands",
      code: "+ 345",
      iso: "KY"
    },
    {
      label: "Chad",
      code: "+235",
      iso: "TD"
    },
    {
      label: "Chile",
      code: "+56",
      iso: "CL"
    },
    {
      label: "China",
      code: "+86",
      iso: "CN"
    },
    {
      label: "Christmas Island",
      code: "+61",
      iso: "CX"
    },
    {
      label: "Cocos Islands",
      code: "+61",
      iso: "CC"
    },
    {
      label: "Colombia",
      code: "+57",
      iso: "CO"
    },
    {
      label: "Comoros",
      code: "+269",
      iso: "KM"
    },
    {
      label: "Congo",
      code: "+242",
      iso: "CG"
    },
    {
      label: "Cook Islands",
      code: "+682",
      iso: "CK"
    },
    {
      label: "Costa Rica",
      code: "+506",
      iso: "CR"
    },
    {
      label: "Cote d'Ivoire",
      code: "+225",
      iso: "CI"
    },
    {
      label: "Croatia",
      code: "+385",
      iso: "HR"
    },
    {
      label: "Cuba",
      code: "+53",
      iso: "CU"
    },
    {
      label: "Cyprus",
      code: "+357",
      iso: "CY"
    },
    {
      label: "Czech Republic",
      code: "+420",
      iso: "CZ"
    },
    {
      label: "Denmark",
      code: "+45",
      iso: "DK"
    },
    {
      label: "Djibouti",
      code: "+253",
      iso: "DJ"
    },
    {
      label: "Dominica",
      code: "+1767",
      iso: "DM"
    },
    {
      label: "Dominican Republic",
      code: "+1849",
      iso: "DO"
    },
    {
      label: "Ecuador",
      code: "+593",
      iso: "EC"
    },
    {
      label: "Egypt",
      code: "+20",
      iso: "EG"
    },
    {
      label: "El Salvador",
      code: "+503",
      iso: "SV"
    },
    {
      label: "Equatorial Guinea",
      code: "+240",
      iso: "GQ"
    },
    {
      label: "Eritrea",
      code: "+291",
      iso: "ER"
    },
    {
      label: "Estonia",
      code: "+372",
      iso: "EE"
    },
    {
      label: "Ethiopia",
      code: "+251",
      iso: "ET"
    },
    {
      label: "Falkland Islands",
      code: "+500",
      iso: "FK"
    },
    {
      label: "Faroe Islands",
      code: "+298",
      iso: "FO"
    },
    {
      label: "Fiji",
      code: "+679",
      iso: "FJ"
    },
    {
      label: "Finland",
      code: "+358",
      iso: "FI"
    },
    {
      label: "France",
      code: "+33",
      iso: "FR"
    },
    {
      label: "French Guiana",
      code: "+594",
      iso: "GF"
    },
    {
      label: "French Polynesia",
      code: "+689",
      iso: "PF"
    },
    {
      label: "Gabon",
      code: "+241",
      iso: "GA"
    },
    {
      label: "Gambia",
      code: "+220",
      iso: "GM"
    },
    {
      label: "Georgia",
      code: "+995",
      iso: "GE"
    },
    {
      label: "Germany",
      code: "+49",
      iso: "DE"
    },
    {
      label: "Ghana",
      code: "+233",
      iso: "GH"
    },
    {
      label: "Gibraltar",
      code: "+350",
      iso: "GI"
    },
    {
      label: "Greece",
      code: "+30",
      iso: "GR"
    },
    {
      label: "Greenland",
      code: "+299",
      iso: "GL"
    },
    {
      label: "Grenada",
      code: "+1473",
      iso: "GD"
    },
    {
      label: "Guadeloupe",
      code: "+590",
      iso: "GP"
    },
    {
      label: "Guam",
      code: "+1671",
      iso: "GU"
    },
    {
      label: "Guatemala",
      code: "+502",
      iso: "GT"
    },
    {
      label: "Guernsey",
      code: "+44",
      iso: "GG"
    },
    {
      label: "Guinea",
      code: "+224",
      iso: "GN"
    },
    {
      label: "Guinea-Bissau",
      code: "+245",
      iso: "GW"
    },
    {
      label: "Guyana",
      code: "+595",
      iso: "GY"
    },
    {
      label: "Haiti",
      code: "+509",
      iso: "HT"
    },
    {
      label: "Holy See",
      code: "+379",
      iso: "VA"
    },
    {
      label: "Honduras",
      code: "+504",
      iso: "HN"
    },
    {
      label: "Hong Kong",
      code: "+852",
      iso: "HK"
    },
    {
      label: "Hungary",
      code: "+36",
      iso: "HU"
    },
    {
      label: "Iceland",
      code: "+354",
      iso: "IS"
    },
    {
      label: "India",
      code: "+91",
      iso: "IN"
    },
    {
      label: "Indonesia",
      code: "+62",
      iso: "ID"
    },
    {
      label: "Iran",
      code: "+98",
      iso: "IR"
    },
    {
      label: "Iraq",
      code: "+964",
      iso: "IQ"
    },
    {
      label: "Ireland",
      code: "+353",
      iso: "IE"
    },
    {
      label: "Isle of Man",
      code: "+44",
      iso: "IM"
    },
    {
      label: "Israel",
      code: "+972",
      iso: "IL"
    },
    {
      label: "Italy",
      code: "+39",
      iso: "IT"
    },
    {
      label: "Jamaica",
      code: "+1876",
      iso: "JM"
    },
    {
      label: "Japan",
      code: "+81",
      iso: "JP"
    },
    {
      label: "Jersey",
      code: "+44",
      iso: "JE"
    },
    {
      label: "Jordan",
      code: "+962",
      iso: "JO"
    },
    {
      label: "Kazakhstan",
      code: "+77",
      iso: "KZ"
    },
    {
      label: "Kenya",
      code: "+254",
      iso: "KE"
    },
    {
      label: "Kiribati",
      code: "+686",
      iso: "KI"
    },
    {
      label: "North Korea,",
      code: "+850",
      iso: "KP"
    },
    {
      label: "South Corea",
      code: "+82",
      iso: "KR"
    },
    {
      label: "Kuwait",
      code: "+965",
      iso: "KW"
    },
    {
      label: "Kyrgyzstan",
      code: "+996",
      iso: "KG"
    },
    {
      label: "Laos",
      code: "+856",
      iso: "LA"
    },
    {
      label: "Latvia",
      code: "+371",
      iso: "LV"
    },
    {
      label: "Lebanon",
      code: "+961",
      iso: "LB"
    },
    {
      label: "Lesotho",
      code: "+266",
      iso: "LS"
    },
    {
      label: "Liberia",
      code: "+231",
      iso: "LR"
    },
    {
      label: "Libyan Arab Jamahiriya",
      code: "+218",
      iso: "LY"
    },
    {
      label: "Liechtenstein",
      code: "+423",
      iso: "LI"
    },
    {
      label: "Lithuania",
      code: "+370",
      iso: "LT"
    },
    {
      label: "Luxembourg",
      code: "+352",
      iso: "LU"
    },
    {
      label: "Macao",
      code: "+853",
      iso: "MO"
    },
    {
      label: "Macedonia",
      code: "+389",
      iso: "MK"
    },
    {
      label: "Madagascar",
      code: "+261",
      iso: "MG"
    },
    {
      label: "Malawi",
      code: "+265",
      iso: "MW"
    },
    {
      label: "Malaysia",
      code: "+60",
      iso: "MY"
    },
    {
      label: "Maldives",
      code: "+960",
      iso: "MV"
    },
    {
      label: "Mali",
      code: "+223",
      iso: "ML"
    },
    {
      label: "Malta",
      code: "+356",
      iso: "MT"
    },
    {
      label: "Marshall Islands",
      code: "+692",
      iso: "MH"
    },
    {
      label: "Martinique",
      code: "+596",
      iso: "MQ"
    },
    {
      label: "Mauritania",
      code: "+222",
      iso: "MR"
    },
    {
      label: "Mauritius",
      code: "+230",
      iso: "MU"
    },
    {
      label: "Mayotte",
      code: "+262",
      iso: "YT"
    },
    {
      label: "Mexico",
      code: "+52",
      iso: "MX"
    },
    {
      label: "Micronesia",
      code: "+691",
      iso: "FM"
    },
    {
      label: "Moldova",
      code: "+373",
      iso: "MD"
    },
    {
      label: "Monaco",
      code: "+377",
      iso: "MC"
    },
    {
      label: "Mongolia",
      code: "+976",
      iso: "MN"
    },
    {
      label: "Montenegro",
      code: "+382",
      iso: "ME"
    },
    {
      label: "Montserrat",
      code: "+1664",
      iso: "MS"
    },
    {
      label: "Morocco",
      code: "+212",
      iso: "MA"
    },
    {
      label: "Mozambique",
      code: "+258",
      iso: "MZ"
    },
    {
      label: "Myanmar",
      code: "+95",
      iso: "MM"
    },
    {
      label: "Namibia",
      code: "+264",
      iso: "NA"
    },
    {
      label: "Nauru",
      code: "+674",
      iso: "NR"
    },
    {
      label: "Nepal",
      code: "+977",
      iso: "NP"
    },
    {
      label: "Netherlands",
      code: "+31",
      iso: "NL"
    },

    {
      label: "New Caledonia",
      code: "+687",
      iso: "NC"
    },
    {
      label: "New Zealand",
      code: "+64",
      iso: "NZ"
    },
    {
      label: "Nicaragua",
      code: "+505",
      iso: "NI"
    },
    {
      label: "Niger",
      code: "+227",
      iso: "NE"
    },
    {
      label: "Nigeria",
      code: "+234",
      iso: "NG"
    },
    {
      label: "Niue",
      code: "+683",
      iso: "NU"
    },
    {
      label: "Norfolk Island",
      code: "+672",
      iso: "NF"
    },
    {
      label: "Northern Mariana Islands",
      code: "+1670",
      iso: "MP"
    },
    {
      label: "Norway",
      code: "+47",
      iso: "NO"
    },
    {
      label: "Oman",
      code: "+968",
      iso: "OM"
    },
    {
      label: "Pakistan",
      code: "+92",
      iso: "PK"
    },
    {
      label: "Palau",
      code: "+680",
      iso: "PW"
    },
    {
      label: "Palestinian",
      code: "+970",
      iso: "PS"
    },
    {
      label: "Panama",
      code: "+507",
      iso: "PA"
    },
    {
      label: "Papua New Guinea",
      code: "+675",
      iso: "PG"
    },
    {
      label: "Paraguay",
      code: "+595",
      iso: "PY"
    },
    {
      label: "Peru",
      code: "+51",
      iso: "PE"
    },
    {
      label: "Philippines",
      code: "+63",
      iso: "PH"
    },
    {
      label: "Pitcairn",
      code: "+872",
      iso: "PN"
    },
    {
      label: "Poland",
      code: "+48",
      iso: "PL"
    },
    {
      label: "Portugal",
      code: "+351",
      iso: "PT"
    },
    {
      label: "Puerto Rico",
      code: "+1939",
      iso: "PR"
    },
    {
      label: "Qatar",
      code: "+974",
      iso: "QA"
    },
    {
      label: "Romania",
      code: "+40",
      iso: "RO"
    },
    {
      label: "Russia",
      code: "+7",
      iso: "RU"
    },
    {
      label: "Rwanda",
      code: "+250",
      iso: "RW"
    },
    {
      label: "Reunion",
      code: "+262",
      iso: "RE"
    },
    {
      label: "Saint Barthelemy",
      code: "+590",
      iso: "BL"
    },
    {
      label: "Saint Helena",
      code: "+290",
      iso: "SH"
    },
    {
      label: "Saint Kitts",
      code: "+1869",
      iso: "KN"
    },
    {
      label: "Saint Lucia",
      code: "+1758",
      iso: "LC"
    },
    {
      label: "Saint Martin",
      code: "+590",
      iso: "MF"
    },
    {
      label: "Saint Pierre",
      code: "+508",
      iso: "PM"
    },
    {
      label: "Saint Vincent",
      code: "+1784",
      iso: "VC"
    },
    {
      label: "Samoa",
      code: "+685",
      iso: "WS"
    },
    {
      label: "San Marino",
      code: "+378",
      iso: "SM"
    },
    {
      label: "Sao Tome and Principe",
      code: "+239",
      iso: "ST"
    },
    {
      label: "Saudi Arabia",
      code: "+966",
      iso: "SA"
    },
    {
      label: "Senegal",
      code: "+221",
      iso: "SN"
    },
    {
      label: "Serbia",
      code: "+381",
      iso: "RS"
    },
    {
      label: "Seychelles",
      code: "+248",
      iso: "SC"
    },
    {
      label: "Sierra Leone",
      code: "+232",
      iso: "SL"
    },
    {
      label: "Singapore",
      code: "+65",
      iso: "SG"
    },
    {
      label: "Slovakia",
      code: "+421",
      iso: "SK"
    },
    {
      label: "Slovenia",
      code: "+386",
      iso: "SI"
    },
    {
      label: "Solomon Islands",
      code: "+677",
      iso: "SB"
    },
    {
      label: "Somalia",
      code: "+252",
      iso: "SO"
    },
    {
      label: "South Africa",
      code: "+27",
      iso: "ZA"
    },
    {
      label: "South Sudan",
      code: "+211",
      iso: "SS"
    },
    {
      label: "South Georgia",
      code: "+500",
      iso: "GS"
    },
    {
      label: "Spain",
      code: "+34",
      iso: "ES"
    },
    {
      label: "Sri Lanka",
      code: "+94",
      iso: "LK"
    },
    {
      label: "Sudan",
      code: "+249",
      iso: "SD"
    },
    {
      label: "Suriname",
      code: "+597",
      iso: "SR"
    },
    {
      label: "Svalbard and Jan Mayen",
      code: "+47",
      iso: "SJ"
    },
    {
      label: "Swaziland",
      code: "+268",
      iso: "SZ"
    },
    {
      label: "Sweden",
      code: "+46",
      iso: "SE"
    },
    {
      label: "Switzerland",
      code: "+41",
      iso: "CH"
    },
    {
      label: "Syrian",
      code: "+963",
      iso: "SY"
    },
    {
      label: "Taiwan",
      code: "+886",
      iso: "TW"
    },
    {
      label: "Tajikistan",
      code: "+992",
      iso: "TJ"
    },
    {
      label: "Tanzania",
      code: "+255",
      iso: "TZ"
    },
    {
      label: "Thailand",
      code: "+66",
      iso: "TH"
    },
    {
      label: "Timor-Leste",
      code: "+670",
      iso: "TL"
    },
    {
      label: "Togo",
      code: "+228",
      iso: "TG"
    },
    {
      label: "Tokelau",
      code: "+690",
      iso: "TK"
    },
    {
      label: "Tonga",
      code: "+676",
      iso: "TO"
    },
    {
      label: "Trinidad and Tobago",
      code: "+1868",
      iso: "TT"
    },
    {
      label: "Tunisia",
      code: "+216",
      iso: "TN"
    },
    {
      label: "Turkey",
      code: "+90",
      iso: "TR"
    },
    {
      label: "Turkmenistan",
      code: "+993",
      iso: "TM"
    },
    {
      label: "Turks",
      code: "+1649",
      iso: "TC"
    },
    {
      label: "Tuvalu",
      code: "+688",
      iso: "TV"
    },
    {
      label: "Uganda",
      code: "+256",
      iso: "UG"
    },
    {
      label: "Ukraine",
      code: "+380",
      iso: "UA"
    },
    {
      label: "United Arab Emirates",
      code: "+971",
      iso: "UAE"
    },
    {
      label: "United Kingdom",
      code: "+44",
      iso: "GB"
    },
    {
      label: "United States",
      code: "+1",
      iso: "US"
    },
    {
      label: "Uruguay",
      code: "+598",
      iso: "UY"
    },
    {
      label: "Uzbekistan",
      code: "+998",
      iso: "UZ"
    },
    {
      label: "Vanuatu",
      code: "+678",
      iso: "VU"
    },
    {
      label: "Venezuela",
      code: "+58",
      iso: "VE"
    },
    {
      label: "Vietnam",
      code: "+84",
      iso: "VN"
    },
    {
      label: "Virgin",
      code: "+1284",
      iso: "VG"
    },
    {
      label: "Virgin Islands, U.S.",
      code: "+1340",
      iso: "VI"
    },
    {
      label: "Wallis and Futuna",
      code: "+681",
      iso: "WF"
    },
    {
      label: "Yemen",
      code: "+967",
      iso: "YE"
    },
    {
      label: "Zambia",
      code: "+260",
      iso: "ZM"
    },
    {
      label: "Zimbabwe",
      code: "+263",
      iso: "ZW"
    }
  ]

export const filterList = [
  { title: "NDC",      column: "ndc", },
  { title: "UPC",      column: "upc", },
  {
    title: "Item Description",
          column: "item_description",
  },
  {
    title: "Generic yn",column: "generic_yn",
  },
  {
    title: "Drop Ship yn",column: "drop_ship_yn",
  },
  {
    title: "Rx Code",column: "rx_code",
  },
  {
    id: 2,
    title: "Account Number",column: "account_number",
  },
  {
    title: "Invoice Number",column: "invoice_number",
  },
  {
    title: "Dc Fill Id",column: "dc_fill_id",
  },

  {
    title: "Rebate Eligible",column: "rebate_eligible",
  }, {
    title: "Specialty YN",column: "specialty_yn",
  }, {
    title: "One Stop YN",column: "one_stop_yn",
  }, {
    title: "Rtl 2 YN",column: "rtl_2_yn",
  },
  {
    title: "Biologics YN",column: "biologics_yn",
  },
];

export const RecentAutoData = [
  {
    "id": 1,
    "name": "rebate statement cov",
    "sender":"John Doe",
    "time":"Apr 13,2025",
    "status":"Pending"
  },
   {
    "id": 2,
    "name": "rebate statement cov",
    "sender":"John Doe",
    "time":"Apr 13,2025",
    "status":"Pending"
  }, {
    "id": 3,
    "name": "rebate statement cov",
    "sender":"John Doe",
    "time":"Apr 13,2025",
    "status":"Pending"
  }, {
    "id": 4,
    "name": "rebate statement cov",
    "sender":"John Doe",
    "time":"Apr 13,2025",
    "status":"Pending"
  }, {
    "id": 5,
    "name": "rebate statement cov",
    "sender":"John Doe",
    "time":"Apr 13,2025",
    "status":"Pending"
  },
  
]


export const FileList = [
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"COGS",
      Status:"Approved",
    },
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"Rebate",
      Status:"Approved",
    },
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"Rebate",
      Status:"Approved",
    },
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"COGS",
      Status:"Approved",
    },
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"COGS",
      Status:"Approved",
    },
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"COGS",
      Status:"Approved",
    },
    {
      key: "1",
      fileName: "File Uploaded",
      UploadedBy:"Vishal",
      UploadedAt:"2025-11-01T04:20:04.000Z",
      FileType:"COGS",
      Status:"Approved",
    },
  ];

  export const tableData = [
  {
    is:1,
    label :'Net Merchandise minus LTC Purchases*',
    fee : "0.25%"
  },
  {
    is:2,
    label :'Net Merchandise minus HIV, Specialty, GLP1, Biosimilars and LTC*',
    fee : "0.12%"
  },
  {
    is:3,
    label :'Net Generic One Stop and Next Stop (MGX) Purchases*',
    fee : "3.40%"
  }
]

export const tableData2 = [
  {
    label :'Pharmacy Selected (RTL2)*',
    fee : "3.00%"
  },
  {
    label :'Warehouse Generic Direct Purchases**',
    fee : "3.00%"
  },
];

export const RebateAndCogsData = [
  {
    FileId:1,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"COGS"
  },
  {
    FileId:2,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"COGS"
  },
  {
    FileId:3,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"Rebate"
  },
  {
    FileId:4,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"Rebate"
  },
  {
    FileId:5,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"Rebate"
  },
  {
    FileId:6,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"Rebate"
  },
  {
    FileId:7,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"Rebate"
  },
    {
    FileId:8,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"COGS"
  },
    {
    FileId:9,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"COGS"
  },
    {
    FileId:10,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"COGS"
  },
    {
    FileId:11,
    AccountId:'96167',
    LockID:"2",
    CUR_BRX_File:'demo',
    CUR_BRX_DB:"Database",
    COG_File:"DEMO",
    COG_DB:"DEMO",
    GCR_File:"Demo FILE",
    GCR_DB:"DEmo",
    accountNumber:'96167',
    accountName:"NEW MO TOWN",
    gcrRatio:"0.34",
    sgcrRatio:"0.3",
    gprRatio:"0.4",
    FileType:"COGS"
  },

]

export const subscriptionDummyData = [
  {
      "id": 1,
      "module_name": "Dashboard",
      "is_active": false,
      "expiry_date": null,
  },
  {
      "id": 2,
      "module_name": "CPI",
      "is_active": false,
      "expiry_date": null,
  },
  {
      "id": 3,
      "module_name": "Management Dashboard",
      "is_active": false,
      "expiry_date": null,
  },
  {
      "id": 4,
      "module_name": "AI Module",
      "is_active": false,
      "expiry_date": null,
  }
]

export const ContactsDummyData = [
  {
      "name": null,
      "title": null,
      "email": null,
      "phone": null,
      "smsFlag": false,
      "type":null,
  },
  {
      "name": null,
      "title": null,
      "email": null,
      "phone": null,
      "smsFlag": false,
      "type":null
  },
  {
      "name": null,
      "title": null,
      "email": null,
      "phone": null,
      "smsFlag": false,
      "type":null
  }
]